
import { encrypt, createMessage, readKey } from "openpgp/lightweight";

export class PgpEncrypt {
    unencryptedfields = [];
    constructor(form, publicKey, fields) {
        this.form = form;
        this.publicKey = publicKey;
        this.unencryptedfields = fields;
    }

    async encryptFields(asTable = false) {

        const keyValuePairs = this.unencryptedfields.map((field) => ({'label': this.form.querySelector(`label[for="${field.id}"]`).innerText, 'value': field.value}) );

        let keyValueString = '';

        if(asTable) {
            keyValuePairs.map((item) => {
               keyValueString += `${item.label}: \n${item.value}\n\n`;
            });
        }
        else {
            keyValueString = JSON.stringify(keyValuePairs);
        }

        const myMessage = await createMessage({text: keyValueString});
        const myPublicKey = await readKey({armoredKey: this.publicKey});

        return await encrypt({
            message: myMessage,
            encryptionKeys: myPublicKey,
        });
    }

    async clearUnencryptedFields() {
        this.unencryptedfields.map((field) => field.value = '-' );
    }
}